module.exports = __webpack_public_path__ + "img/2by2.10a475c5.svg";